var sr = Object.defineProperty;
var ar = (t, n, r) => n in t ? sr(t, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[n] = r;
var E = (t, n, r) => ar(t, typeof n != "symbol" ? n + "" : n, r);
var It = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Pe = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, At = new Array(4).fill(String.fromCodePoint(Pe[0])).join(""), ht = "\0";
function or(t) {
  let n = JSON.stringify(t);
  return `${At}${Array.from(n).map((r) => {
    let a = r.charCodeAt(0);
    if (a > 255) throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${n} on character ${r} (${a})`);
    return Array.from(a.toString(4).padStart(4, "0")).map((s) => String.fromCodePoint(Pe[s])).join("");
  }).join("")}`;
}
function cr(t) {
  return !Number.isNaN(Number(t)) || /[a-z]/i.test(t) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(t) ? !1 : !!Date.parse(t);
}
function lr(t) {
  try {
    new URL(t, t.startsWith("/") ? "https://acme.com" : void 0);
  } catch {
    return !1;
  }
  return !0;
}
function ur(t, n, r = "auto") {
  return r === !0 || r === "auto" && (cr(t) || lr(t)) ? t : `${t}${or(n)}`;
}
var fr = Object.fromEntries(Object.entries(Pe).map((t) => t.reverse())), yt = Object.fromEntries(Object.entries(It).map((t) => t.reverse())), dr = `${Object.values(It).map((t) => `\\u{${t.toString(16)}}`).join("")}`, Be = new RegExp(`[${dr}]{4,}`, "gu");
function pr(t) {
  let n = t.match(Be);
  if (n) return gr(n[0], !0)[0];
}
function gr(t, n = !1) {
  let r = Array.from(t);
  if (r.length % 2 === 0) {
    if (r.length % 4 || !t.startsWith(At)) return hr(r, n);
  } else throw new Error("Encoded data has invalid length");
  let a = [];
  for (let s = r.length * 0.25; s--; ) {
    let c = r.slice(s * 4, s * 4 + 4).map((u) => fr[u.codePointAt(0)]).join("");
    a.unshift(String.fromCharCode(parseInt(c, 4)));
  }
  if (n) {
    a.shift();
    let s = a.indexOf(ht);
    return s === -1 && (s = a.length), [JSON.parse(a.slice(0, s).join(""))];
  }
  return a.join("").split(ht).filter(Boolean).map((s) => JSON.parse(s));
}
function hr(t, n) {
  var r;
  let a = [];
  for (let f = t.length * 0.5; f--; ) {
    let l = `${yt[t[f * 2].codePointAt(0)]}${yt[t[f * 2 + 1].codePointAt(0)]}`;
    a.unshift(String.fromCharCode(parseInt(l, 16)));
  }
  let s = [], c = [a.join("")], u = 10;
  for (; c.length; ) {
    let f = c.shift();
    try {
      if (s.push(JSON.parse(f)), n) return s;
    } catch (l) {
      if (!u--) throw l;
      let p = +((r = l.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : r[1]);
      if (!p) throw l;
      c.unshift(f.substring(0, p), f.substring(p));
    }
  }
  return s;
}
function yr(t) {
  var n;
  return { cleaned: t.replace(Be, ""), encoded: ((n = t.match(Be)) == null ? void 0 : n[0]) || "" };
}
function de(t, n) {
  return ur(t, n);
}
function Er(t) {
  return pr(t);
}
function si(t) {
  return yr(t);
}
var xe, Et;
function mr() {
  if (Et) return xe;
  Et = 1;
  var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  return xe = function(r, a, s) {
    if (n.call(a) !== "[object Function]")
      throw new TypeError("iterator must be a function");
    var c = r.length;
    if (c === +c)
      for (var u = 0; u < c; u++)
        a.call(s, r[u], u, r);
    else
      for (var f in r)
        t.call(r, f) && a.call(s, r[f], f, r);
  }, xe;
}
var je, mt;
function br() {
  if (mt) return je;
  mt = 1;
  var t = mr();
  je = n;
  function n(r, a, s) {
    if (arguments.length === 3)
      return n.set(r, a, s);
    if (arguments.length === 2)
      return n.get(r, a);
    var c = n.bind(n, r);
    for (var u in n)
      n.hasOwnProperty(u) && (c[u] = n[u].bind(c, r));
    return c;
  }
  return n.get = function(r, a) {
    for (var s = Array.isArray(a) ? a : n.parse(a), c = 0; c < s.length; ++c) {
      var u = s[c];
      if (!(typeof r == "object" && u in r))
        throw new Error("Invalid reference token: " + u);
      r = r[u];
    }
    return r;
  }, n.set = function(r, a, s) {
    var c = Array.isArray(a) ? a : n.parse(a), u = c[0];
    if (c.length === 0)
      throw Error("Can not set the root object");
    for (var f = 0; f < c.length - 1; ++f) {
      var l = c[f];
      typeof l != "string" && typeof l != "number" && (l = String(l)), !(l === "__proto__" || l === "constructor" || l === "prototype") && (l === "-" && Array.isArray(r) && (l = r.length), u = c[f + 1], l in r || (u.match(/^(\d+|-)$/) ? r[l] = [] : r[l] = {}), r = r[l]);
    }
    return u === "-" && Array.isArray(r) && (u = r.length), r[u] = s, this;
  }, n.remove = function(r, a) {
    var s = Array.isArray(a) ? a : n.parse(a), c = s[s.length - 1];
    if (c === void 0)
      throw new Error('Invalid JSON pointer for remove: "' + a + '"');
    var u = n.get(r, s.slice(0, -1));
    if (Array.isArray(u)) {
      var f = +c;
      if (c === "" && isNaN(f))
        throw new Error('Invalid array index: "' + c + '"');
      Array.prototype.splice.call(u, f, 1);
    } else
      delete u[c];
  }, n.dict = function(r, a) {
    var s = {};
    return n.walk(r, function(c, u) {
      s[u] = c;
    }, a), s;
  }, n.walk = function(r, a, s) {
    var c = [];
    s = s || function(u) {
      var f = Object.prototype.toString.call(u);
      return f === "[object Object]" || f === "[object Array]";
    }, function u(f) {
      t(f, function(l, p) {
        c.push(String(p)), s(l) ? u(l) : a(l, n.compile(c)), c.pop();
      });
    }(r);
  }, n.has = function(r, a) {
    try {
      n.get(r, a);
    } catch {
      return !1;
    }
    return !0;
  }, n.escape = function(r) {
    return r.toString().replace(/~/g, "~0").replace(/\//g, "~1");
  }, n.unescape = function(r) {
    return r.replace(/~1/g, "/").replace(/~0/g, "~");
  }, n.parse = function(r) {
    if (r === "")
      return [];
    if (r.charAt(0) !== "/")
      throw new Error("Invalid JSON pointer: " + r);
    return r.substring(1).split(/\//).map(n.unescape);
  }, n.compile = function(r) {
    return r.length === 0 ? "" : "/" + r.map(n.escape).join("/");
  }, je;
}
var j = br();
const vr = ({
  pointer: t,
  mappings: n,
  data: r,
  hiddenStrings: a
}) => {
  const s = n[t];
  if (s) {
    delete n[t];
    const c = Ge(r, t);
    for (const u of c) {
      n[u] = s;
      const f = j.get(r, u), l = de(f, a);
      j.set(r, u, l);
    }
  } else {
    const c = Ge(r, t);
    for (const u of c) {
      const f = j.get(r, u), l = de(f, a);
      j.set(r, u, l);
    }
  }
}, Ge = (t, n = "") => {
  const r = [], a = j.get(t, n);
  if (a.content)
    for (let s = 0; s < a.content.length; s++)
      a.content[s].nodeType === "text" ? r.push(`${n}/content/${s}/value`) : r.push(...Ge(t, `${n}/content/${s}`));
  return r;
}, Fe = ({
  entityId: t,
  entityType: n,
  space: r,
  environment: a,
  field: s,
  locale: c,
  editorInterface: u,
  fieldType: f,
  targetOrigin: l,
  platform: p
}) => {
  const h = {
    origin: "contentful.com",
    href: `${`${l || "https://app.contentful.com"}/spaces/${r}/environments/${a}`}/${n === "Entry" ? "entries" : "assets"}/${t}/?focusedField=${s}&focusedLocale=${c}&source=vercel-content-link`,
    contentful: {
      editorInterface: u,
      fieldType: f
    }
  };
  return p === "vercel" && delete h.contentful, h;
}, Ot = (t) => ["builtin", "sidebar-builtin", "editor-builtin"].includes(t), wt = (t) => Tr.includes(t);
function Ct(t) {
  if (typeof structuredClone == "function")
    return structuredClone(t);
  try {
    return JSON.parse(JSON.stringify(t));
  } catch (n) {
    return console.warn("Failed to clone data:", t, n), t;
  }
}
const Tr = [
  "singleLine",
  "tagEditor",
  "listInput",
  "checkbox",
  "richTextEditor",
  "multipleLine"
];
function ze(t, n, r, a, s, c, u) {
  const f = u ? n[u] : n;
  switch (t) {
    case "Symbol": {
      const l = de(f, r);
      j.set(a, s, l);
      break;
    }
    case "Text": {
      const l = de(f, r);
      j.set(a, s, l);
      break;
    }
    case "RichText": {
      vr({
        pointer: "",
        mappings: c,
        data: f,
        hiddenStrings: r
      });
      break;
    }
    case "Array": {
      const l = f.map((p) => typeof p == "string" ? de(p, r) : p);
      j.set(a, s, l);
      break;
    }
  }
}
const ai = (t, n, r) => {
  if (!t || !t.extensions || !t.extensions.contentSourceMaps)
    return console.error(
      "GraphQL response does not contain Content Source Maps information.",
      t
    ), t;
  const a = Ct(t), {
    spaces: s,
    environments: c,
    editorInterfaces: u,
    fields: f,
    locales: l,
    entries: p,
    assets: h,
    mappings: g,
    fieldTypes: T
  } = a.extensions.contentSourceMaps, N = a;
  for (const A in g) {
    const { source: _ } = g[A], D = "entry" in _ ? p[_.entry] : h[_.asset], G = "entry" in _ ? "Entry" : "Asset";
    if (!D)
      return a;
    const $ = s[D.space], F = c[D.environment], se = D.id, pe = f[_.field], ne = l[_.locale], re = u[_.editorInterface], ge = T[_.fieldType];
    if (!(Ot(re.widgetNamespace) && !wt(re.widgetId)) && j.has(N, A)) {
      const he = j.get(N, A);
      if (he !== null) {
        const ae = Fe({
          entityId: se,
          entityType: G,
          space: $,
          environment: F,
          field: pe,
          locale: ne,
          editorInterface: re,
          fieldType: ge,
          targetOrigin: n,
          platform: r
        });
        ze(ge, he, ae, N, A, g);
      }
    }
  }
  return a;
}, Ae = (t, n, r, a, s) => {
  if (!t.fields)
    return;
  const { contentSourceMaps: c } = t.sys;
  if (!c) {
    console.error("Content source maps data is missing");
    return;
  }
  const { mappings: u } = c;
  for (const f in u) {
    const { source: l } = u[f], p = t.sys.space.sys.id, h = t.sys.environment.sys.id, g = t.sys.id, T = t.sys.type, N = n[l.fieldType], A = r[l.editorInterface];
    if (Ot(A.widgetNamespace) && !wt(A.widgetId))
      continue;
    const _ = f.startsWith("/") ? f : `/${f}`;
    if (j.has(t, _)) {
      const D = j.get(t, _);
      if (D === null)
        return;
      const G = _.split("/").pop();
      if (!G) {
        console.error("Field name could not be extracted from the pointer", _);
        return;
      }
      const $ = t.sys.locale;
      if ($) {
        const F = Fe({
          entityId: g,
          entityType: T,
          space: p,
          environment: h,
          field: G,
          locale: $,
          editorInterface: A,
          fieldType: N,
          targetOrigin: a,
          platform: s
        });
        ze(N, D, F, t, _, u);
      } else
        Object.keys(D).forEach((F) => {
          const se = Fe({
            entityId: g,
            entityType: T,
            space: p,
            environment: h,
            field: G,
            locale: F,
            editorInterface: A,
            fieldType: N,
            targetOrigin: a,
            platform: s
          });
          ze(
            N,
            D,
            se,
            t,
            `${_}/${F}`,
            u,
            F
          );
        });
    }
  }
}, oi = (t, n, r) => {
  var a;
  const s = Ct(
    t
  );
  if (s.sys && "items" in s) {
    const c = s;
    if (!((a = c.sys) != null && a.contentSourceMapsLookup))
      return console.error("Content source maps lookup data is missing"), c;
    const {
      contentSourceMapsLookup: { fieldTypes: u, editorInterfaces: f }
    } = c.sys, { items: l, includes: p } = c;
    l.forEach(
      (h) => Ae(h, u, f, n, r)
    ), p && p.Entry && p.Entry.forEach(
      (h) => Ae(h, u, f, n, r)
    ), p && p.Asset && p.Asset.forEach(
      (h) => Ae(h, u, f, n, r)
    );
  } else {
    const c = s;
    if (!c.sys.contentSourceMapsLookup)
      return console.error("Content source maps lookup data is missing"), c;
    Ae(
      c,
      c.sys.contentSourceMapsLookup.fieldTypes,
      c.sys.contentSourceMapsLookup.editorInterfaces,
      n,
      r
    );
  }
  return s;
}, Dt = "4.6.4";
let Lt = !1;
function bt(t) {
  Lt = t;
}
const $e = (t) => (...n) => {
  Lt && console[t](...n);
}, M = {
  error: $e("error"),
  warn: $e("warn"),
  log: $e("log")
};
function _r(t, n = 500) {
  let r = window.location.href;
  const s = setInterval(() => {
    const c = window.location.href;
    c !== r && (r = c, t(c));
  }, n);
  return () => clearInterval(s);
}
const Sr = "live-preview-editor", Ir = "live-preview-sdk";
function P(t, n, r) {
  const a = {
    ...n,
    method: t,
    source: Ir,
    location: window.location.href,
    version: Dt
  };
  M.log("Send message", a), r.forEach((s) => {
    var c;
    (c = window.top) == null || c.postMessage(a, s);
  });
}
function Ar(t, n = 100) {
  let r;
  return (...a) => {
    clearTimeout(r), r = setTimeout(() => {
      t.apply(this, a);
    }, n);
  };
}
function Or() {
  var t;
  try {
    return ((t = window.top) == null ? void 0 : t.location.href) !== window.location.href;
  } catch {
    return !0;
  }
}
function wr() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function Cr(t) {
  return typeof t.data != "object" || !t.data ? !1 : "source" in t.data && t.data.source === Sr;
}
var Oe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Dr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var fe = { exports: {} };
fe.exports;
var vt;
function Lr() {
  return vt || (vt = 1, function(t, n) {
    var r = 200, a = "__lodash_hash_undefined__", s = 1, c = 2, u = 9007199254740991, f = "[object Arguments]", l = "[object Array]", p = "[object AsyncFunction]", h = "[object Boolean]", g = "[object Date]", T = "[object Error]", N = "[object Function]", A = "[object GeneratorFunction]", _ = "[object Map]", D = "[object Number]", G = "[object Null]", $ = "[object Object]", F = "[object Promise]", se = "[object Proxy]", pe = "[object RegExp]", ne = "[object Set]", re = "[object String]", ge = "[object Symbol]", he = "[object Undefined]", ae = "[object WeakMap]", Ve = "[object ArrayBuffer]", ye = "[object DataView]", xt = "[object Float32Array]", jt = "[object Float64Array]", $t = "[object Int8Array]", Bt = "[object Int16Array]", Gt = "[object Int32Array]", Ft = "[object Uint8Array]", zt = "[object Uint8ClampedArray]", Pt = "[object Uint16Array]", Ht = "[object Uint32Array]", Vt = /[\\^$.*+?()[\]{}|]/g, Yt = /^\[object .+?Constructor\]$/, qt = /^(?:0|[1-9]\d*)$/, b = {};
    b[xt] = b[jt] = b[$t] = b[Bt] = b[Gt] = b[Ft] = b[zt] = b[Pt] = b[Ht] = !0, b[f] = b[l] = b[Ve] = b[h] = b[ye] = b[g] = b[T] = b[N] = b[_] = b[D] = b[$] = b[pe] = b[ne] = b[re] = b[ae] = !1;
    var Ye = typeof Oe == "object" && Oe && Oe.Object === Object && Oe, Kt = typeof self == "object" && self && self.Object === Object && self, V = Ye || Kt || Function("return this")(), qe = n && !n.nodeType && n, Ke = qe && !0 && t && !t.nodeType && t, Je = Ke && Ke.exports === qe, we = Je && Ye.process, We = function() {
      try {
        return we && we.binding && we.binding("util");
      } catch {
      }
    }(), Ze = We && We.isTypedArray;
    function Jt(e, i) {
      for (var o = -1, d = e == null ? 0 : e.length, v = 0, y = []; ++o < d; ) {
        var I = e[o];
        i(I, o, e) && (y[v++] = I);
      }
      return y;
    }
    function Wt(e, i) {
      for (var o = -1, d = i.length, v = e.length; ++o < d; )
        e[v + o] = i[o];
      return e;
    }
    function Zt(e, i) {
      for (var o = -1, d = e == null ? 0 : e.length; ++o < d; )
        if (i(e[o], o, e))
          return !0;
      return !1;
    }
    function Xt(e, i) {
      for (var o = -1, d = Array(e); ++o < e; )
        d[o] = i(o);
      return d;
    }
    function Qt(e) {
      return function(i) {
        return e(i);
      };
    }
    function kt(e, i) {
      return e.has(i);
    }
    function en(e, i) {
      return e == null ? void 0 : e[i];
    }
    function tn(e) {
      var i = -1, o = Array(e.size);
      return e.forEach(function(d, v) {
        o[++i] = [v, d];
      }), o;
    }
    function nn(e, i) {
      return function(o) {
        return e(i(o));
      };
    }
    function rn(e) {
      var i = -1, o = Array(e.size);
      return e.forEach(function(d) {
        o[++i] = d;
      }), o;
    }
    var sn = Array.prototype, an = Function.prototype, Ee = Object.prototype, Ce = V["__core-js_shared__"], Xe = an.toString, z = Ee.hasOwnProperty, Qe = function() {
      var e = /[^.]+$/.exec(Ce && Ce.keys && Ce.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }(), ke = Ee.toString, on = RegExp(
      "^" + Xe.call(z).replace(Vt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), et = Je ? V.Buffer : void 0, me = V.Symbol, tt = V.Uint8Array, nt = Ee.propertyIsEnumerable, cn = sn.splice, Z = me ? me.toStringTag : void 0, rt = Object.getOwnPropertySymbols, ln = et ? et.isBuffer : void 0, un = nn(Object.keys, Object), De = ie(V, "DataView"), oe = ie(V, "Map"), Le = ie(V, "Promise"), Ne = ie(V, "Set"), Re = ie(V, "WeakMap"), ce = ie(Object, "create"), fn = k(De), dn = k(oe), pn = k(Le), gn = k(Ne), hn = k(Re), it = me ? me.prototype : void 0, Me = it ? it.valueOf : void 0;
    function X(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.clear(); ++i < o; ) {
        var d = e[i];
        this.set(d[0], d[1]);
      }
    }
    function yn() {
      this.__data__ = ce ? ce(null) : {}, this.size = 0;
    }
    function En(e) {
      var i = this.has(e) && delete this.__data__[e];
      return this.size -= i ? 1 : 0, i;
    }
    function mn(e) {
      var i = this.__data__;
      if (ce) {
        var o = i[e];
        return o === a ? void 0 : o;
      }
      return z.call(i, e) ? i[e] : void 0;
    }
    function bn(e) {
      var i = this.__data__;
      return ce ? i[e] !== void 0 : z.call(i, e);
    }
    function vn(e, i) {
      var o = this.__data__;
      return this.size += this.has(e) ? 0 : 1, o[e] = ce && i === void 0 ? a : i, this;
    }
    X.prototype.clear = yn, X.prototype.delete = En, X.prototype.get = mn, X.prototype.has = bn, X.prototype.set = vn;
    function Y(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.clear(); ++i < o; ) {
        var d = e[i];
        this.set(d[0], d[1]);
      }
    }
    function Tn() {
      this.__data__ = [], this.size = 0;
    }
    function _n(e) {
      var i = this.__data__, o = ve(i, e);
      if (o < 0)
        return !1;
      var d = i.length - 1;
      return o == d ? i.pop() : cn.call(i, o, 1), --this.size, !0;
    }
    function Sn(e) {
      var i = this.__data__, o = ve(i, e);
      return o < 0 ? void 0 : i[o][1];
    }
    function In(e) {
      return ve(this.__data__, e) > -1;
    }
    function An(e, i) {
      var o = this.__data__, d = ve(o, e);
      return d < 0 ? (++this.size, o.push([e, i])) : o[d][1] = i, this;
    }
    Y.prototype.clear = Tn, Y.prototype.delete = _n, Y.prototype.get = Sn, Y.prototype.has = In, Y.prototype.set = An;
    function Q(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.clear(); ++i < o; ) {
        var d = e[i];
        this.set(d[0], d[1]);
      }
    }
    function On() {
      this.size = 0, this.__data__ = {
        hash: new X(),
        map: new (oe || Y)(),
        string: new X()
      };
    }
    function wn(e) {
      var i = Te(this, e).delete(e);
      return this.size -= i ? 1 : 0, i;
    }
    function Cn(e) {
      return Te(this, e).get(e);
    }
    function Dn(e) {
      return Te(this, e).has(e);
    }
    function Ln(e, i) {
      var o = Te(this, e), d = o.size;
      return o.set(e, i), this.size += o.size == d ? 0 : 1, this;
    }
    Q.prototype.clear = On, Q.prototype.delete = wn, Q.prototype.get = Cn, Q.prototype.has = Dn, Q.prototype.set = Ln;
    function be(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.__data__ = new Q(); ++i < o; )
        this.add(e[i]);
    }
    function Nn(e) {
      return this.__data__.set(e, a), this;
    }
    function Rn(e) {
      return this.__data__.has(e);
    }
    be.prototype.add = be.prototype.push = Nn, be.prototype.has = Rn;
    function K(e) {
      var i = this.__data__ = new Y(e);
      this.size = i.size;
    }
    function Mn() {
      this.__data__ = new Y(), this.size = 0;
    }
    function Un(e) {
      var i = this.__data__, o = i.delete(e);
      return this.size = i.size, o;
    }
    function xn(e) {
      return this.__data__.get(e);
    }
    function jn(e) {
      return this.__data__.has(e);
    }
    function $n(e, i) {
      var o = this.__data__;
      if (o instanceof Y) {
        var d = o.__data__;
        if (!oe || d.length < r - 1)
          return d.push([e, i]), this.size = ++o.size, this;
        o = this.__data__ = new Q(d);
      }
      return o.set(e, i), this.size = o.size, this;
    }
    K.prototype.clear = Mn, K.prototype.delete = Un, K.prototype.get = xn, K.prototype.has = jn, K.prototype.set = $n;
    function Bn(e, i) {
      var o = _e(e), d = !o && kn(e), v = !o && !d && Ue(e), y = !o && !d && !v && pt(e), I = o || d || v || y, O = I ? Xt(e.length, String) : [], w = O.length;
      for (var S in e)
        z.call(e, S) && !(I && // Safari 9 has enumerable `arguments.length` in strict mode.
        (S == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        v && (S == "offset" || S == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        y && (S == "buffer" || S == "byteLength" || S == "byteOffset") || // Skip index properties.
        Jn(S, w))) && O.push(S);
      return O;
    }
    function ve(e, i) {
      for (var o = e.length; o--; )
        if (lt(e[o][0], i))
          return o;
      return -1;
    }
    function Gn(e, i, o) {
      var d = i(e);
      return _e(e) ? d : Wt(d, o(e));
    }
    function le(e) {
      return e == null ? e === void 0 ? he : G : Z && Z in Object(e) ? qn(e) : Qn(e);
    }
    function st(e) {
      return ue(e) && le(e) == f;
    }
    function at(e, i, o, d, v) {
      return e === i ? !0 : e == null || i == null || !ue(e) && !ue(i) ? e !== e && i !== i : Fn(e, i, o, d, at, v);
    }
    function Fn(e, i, o, d, v, y) {
      var I = _e(e), O = _e(i), w = I ? l : J(e), S = O ? l : J(i);
      w = w == f ? $ : w, S = S == f ? $ : S;
      var R = w == $, B = S == $, C = w == S;
      if (C && Ue(e)) {
        if (!Ue(i))
          return !1;
        I = !0, R = !1;
      }
      if (C && !R)
        return y || (y = new K()), I || pt(e) ? ot(e, i, o, d, v, y) : Vn(e, i, w, o, d, v, y);
      if (!(o & s)) {
        var U = R && z.call(e, "__wrapped__"), x = B && z.call(i, "__wrapped__");
        if (U || x) {
          var W = U ? e.value() : e, q = x ? i.value() : i;
          return y || (y = new K()), v(W, q, o, d, y);
        }
      }
      return C ? (y || (y = new K()), Yn(e, i, o, d, v, y)) : !1;
    }
    function zn(e) {
      if (!dt(e) || Zn(e))
        return !1;
      var i = ut(e) ? on : Yt;
      return i.test(k(e));
    }
    function Pn(e) {
      return ue(e) && ft(e.length) && !!b[le(e)];
    }
    function Hn(e) {
      if (!Xn(e))
        return un(e);
      var i = [];
      for (var o in Object(e))
        z.call(e, o) && o != "constructor" && i.push(o);
      return i;
    }
    function ot(e, i, o, d, v, y) {
      var I = o & s, O = e.length, w = i.length;
      if (O != w && !(I && w > O))
        return !1;
      var S = y.get(e);
      if (S && y.get(i))
        return S == i;
      var R = -1, B = !0, C = o & c ? new be() : void 0;
      for (y.set(e, i), y.set(i, e); ++R < O; ) {
        var U = e[R], x = i[R];
        if (d)
          var W = I ? d(x, U, R, i, e, y) : d(U, x, R, e, i, y);
        if (W !== void 0) {
          if (W)
            continue;
          B = !1;
          break;
        }
        if (C) {
          if (!Zt(i, function(q, ee) {
            if (!kt(C, ee) && (U === q || v(U, q, o, d, y)))
              return C.push(ee);
          })) {
            B = !1;
            break;
          }
        } else if (!(U === x || v(U, x, o, d, y))) {
          B = !1;
          break;
        }
      }
      return y.delete(e), y.delete(i), B;
    }
    function Vn(e, i, o, d, v, y, I) {
      switch (o) {
        case ye:
          if (e.byteLength != i.byteLength || e.byteOffset != i.byteOffset)
            return !1;
          e = e.buffer, i = i.buffer;
        case Ve:
          return !(e.byteLength != i.byteLength || !y(new tt(e), new tt(i)));
        case h:
        case g:
        case D:
          return lt(+e, +i);
        case T:
          return e.name == i.name && e.message == i.message;
        case pe:
        case re:
          return e == i + "";
        case _:
          var O = tn;
        case ne:
          var w = d & s;
          if (O || (O = rn), e.size != i.size && !w)
            return !1;
          var S = I.get(e);
          if (S)
            return S == i;
          d |= c, I.set(e, i);
          var R = ot(O(e), O(i), d, v, y, I);
          return I.delete(e), R;
        case ge:
          if (Me)
            return Me.call(e) == Me.call(i);
      }
      return !1;
    }
    function Yn(e, i, o, d, v, y) {
      var I = o & s, O = ct(e), w = O.length, S = ct(i), R = S.length;
      if (w != R && !I)
        return !1;
      for (var B = w; B--; ) {
        var C = O[B];
        if (!(I ? C in i : z.call(i, C)))
          return !1;
      }
      var U = y.get(e);
      if (U && y.get(i))
        return U == i;
      var x = !0;
      y.set(e, i), y.set(i, e);
      for (var W = I; ++B < w; ) {
        C = O[B];
        var q = e[C], ee = i[C];
        if (d)
          var gt = I ? d(ee, q, C, i, e, y) : d(q, ee, C, e, i, y);
        if (!(gt === void 0 ? q === ee || v(q, ee, o, d, y) : gt)) {
          x = !1;
          break;
        }
        W || (W = C == "constructor");
      }
      if (x && !W) {
        var Se = e.constructor, Ie = i.constructor;
        Se != Ie && "constructor" in e && "constructor" in i && !(typeof Se == "function" && Se instanceof Se && typeof Ie == "function" && Ie instanceof Ie) && (x = !1);
      }
      return y.delete(e), y.delete(i), x;
    }
    function ct(e) {
      return Gn(e, nr, Kn);
    }
    function Te(e, i) {
      var o = e.__data__;
      return Wn(i) ? o[typeof i == "string" ? "string" : "hash"] : o.map;
    }
    function ie(e, i) {
      var o = en(e, i);
      return zn(o) ? o : void 0;
    }
    function qn(e) {
      var i = z.call(e, Z), o = e[Z];
      try {
        e[Z] = void 0;
        var d = !0;
      } catch {
      }
      var v = ke.call(e);
      return d && (i ? e[Z] = o : delete e[Z]), v;
    }
    var Kn = rt ? function(e) {
      return e == null ? [] : (e = Object(e), Jt(rt(e), function(i) {
        return nt.call(e, i);
      }));
    } : rr, J = le;
    (De && J(new De(new ArrayBuffer(1))) != ye || oe && J(new oe()) != _ || Le && J(Le.resolve()) != F || Ne && J(new Ne()) != ne || Re && J(new Re()) != ae) && (J = function(e) {
      var i = le(e), o = i == $ ? e.constructor : void 0, d = o ? k(o) : "";
      if (d)
        switch (d) {
          case fn:
            return ye;
          case dn:
            return _;
          case pn:
            return F;
          case gn:
            return ne;
          case hn:
            return ae;
        }
      return i;
    });
    function Jn(e, i) {
      return i = i ?? u, !!i && (typeof e == "number" || qt.test(e)) && e > -1 && e % 1 == 0 && e < i;
    }
    function Wn(e) {
      var i = typeof e;
      return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? e !== "__proto__" : e === null;
    }
    function Zn(e) {
      return !!Qe && Qe in e;
    }
    function Xn(e) {
      var i = e && e.constructor, o = typeof i == "function" && i.prototype || Ee;
      return e === o;
    }
    function Qn(e) {
      return ke.call(e);
    }
    function k(e) {
      if (e != null) {
        try {
          return Xe.call(e);
        } catch {
        }
        try {
          return e + "";
        } catch {
        }
      }
      return "";
    }
    function lt(e, i) {
      return e === i || e !== e && i !== i;
    }
    var kn = st(/* @__PURE__ */ function() {
      return arguments;
    }()) ? st : function(e) {
      return ue(e) && z.call(e, "callee") && !nt.call(e, "callee");
    }, _e = Array.isArray;
    function er(e) {
      return e != null && ft(e.length) && !ut(e);
    }
    var Ue = ln || ir;
    function tr(e, i) {
      return at(e, i);
    }
    function ut(e) {
      if (!dt(e))
        return !1;
      var i = le(e);
      return i == N || i == A || i == p || i == se;
    }
    function ft(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
    }
    function dt(e) {
      var i = typeof e;
      return e != null && (i == "object" || i == "function");
    }
    function ue(e) {
      return e != null && typeof e == "object";
    }
    var pt = Ze ? Qt(Ze) : Pn;
    function nr(e) {
      return er(e) ? Bn(e) : Hn(e);
    }
    function rr() {
      return [];
    }
    function ir() {
      return !1;
    }
    t.exports = tr;
  }(fe, fe.exports)), fe.exports;
}
var Nr = Lr();
const Rr = /* @__PURE__ */ Dr(Nr);
var m = /* @__PURE__ */ ((t) => (t.FIELD_ID = "data-contentful-field-id", t.ENTRY_ID = "data-contentful-entry-id", t.ASSET_ID = "data-contentful-asset-id", t.LOCALE = "data-contentful-locale", t.SPACE = "data-contentful-space", t.ENVIRONMENT = "data-contentful-environment", t))(m || {}), te = /* @__PURE__ */ ((t) => (t.MOUSE_MOVE = "MOUSE_MOVE", t.SCROLL_START = "SCROLL_START", t.SCROLL_END = "SCROLL_END", t.RESIZE_START = "RESIZE_START", t.RESIZE_END = "RESIZE_END", t.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", t.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", t))(te || {}), Nt = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Rt = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 };
new Array(4).fill(String.fromCodePoint(Rt[0])).join("");
Object.fromEntries(Object.entries(Rt).map((t) => t.reverse()));
Object.fromEntries(Object.entries(Nt).map((t) => t.reverse()));
var Mr = `${Object.values(Nt).map((t) => `\\u{${t.toString(16)}}`).join("")}`, Ur = new RegExp(`[${Mr}]{4,}`, "gu");
const xr = (t) => {
  if (!t || t.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const n = t;
  return !(!n.hasAttribute(m.FIELD_ID) || !n.hasAttribute(m.ENTRY_ID) && !n.hasAttribute(m.ASSET_ID));
};
function jr(t, n) {
  if (!xr(t))
    return null;
  const r = {
    fieldId: t.getAttribute(m.FIELD_ID),
    locale: t.getAttribute(m.LOCALE) ?? n.locale,
    environment: t.getAttribute(m.ENVIRONMENT) ?? n.environment,
    space: t.getAttribute(m.SPACE) ?? n.space,
    manuallyTagged: !0
  };
  if (!r.fieldId)
    return M.warn("Element is missing field ID attribute and cannot be tagged", {
      id: t.getAttribute(m.ENTRY_ID) ?? t.getAttribute(m.ASSET_ID),
      sharedProps: r
    }), null;
  const a = t.getAttribute(m.ENTRY_ID);
  if (a)
    return { ...r, entryId: a };
  const s = t.getAttribute(m.ASSET_ID);
  return s ? { ...r, assetId: s } : null;
}
function Mt(t, n) {
  return t.href === n.href;
}
function $r(t, n) {
  return !(!Mt(t.sourceMap, n.sourceMap) || t.element !== n.element);
}
function Br(t) {
  let n = [];
  return typeof t.matches == "function" && t.matches("*") && (n = [t]), [
    ...n,
    ...Array.from(t.querySelectorAll("*:not(script,style,meta,title)"))
  ].map((r) => ({ node: r, text: Gr(r) })).filter(({ text: r }) => !!(r && r.match(Ur)));
}
function Gr(t) {
  return t.matches("input[type=submit], input[type=button], input[type=reset]") ? t.value : t.matches("img, video") ? t.alt : Array.from(t.childNodes).filter((n) => n.nodeType === Node.TEXT_NODE && !!n.textContent).map((n) => n.textContent).join("");
}
function Fr(t, n) {
  for (const r of n)
    if (r.element === t || r.element.contains(t))
      return !0;
  return !1;
}
function He({
  root: t = window.document,
  options: n
}) {
  const a = [...n.ignoreManuallyTaggedElements ? [] : t.querySelectorAll(
    `[${m.ASSET_ID}][${m.FIELD_ID}], [${m.ENTRY_ID}][${m.FIELD_ID}]`
  )].map((l) => ({
    element: l,
    attributes: jr(l, n)
  })).filter(({ attributes: l }) => l !== null), s = [], c = Br("body" in t ? t.body : t);
  for (const { node: l, text: p } of c) {
    const h = Er(p);
    if (!h || !h.origin.includes("contentful.com")) {
      M.warn(
        "Element has missing or invalid ContentSourceMap, please check if you have correctly enabled ContentSourceMaps and that the element's data originates from Contentful",
        {
          node: l,
          sourceMap: h
        }
      );
      continue;
    }
    if (!(Fr(l, a) || s.some(
      (g) => g.element.contains(l) && Mt(g.sourceMap, h)
    ))) {
      if (l.matches("img")) {
        const g = l.closest("figure") || l.closest("picture") || l;
        s.push({ element: g, sourceMap: h });
        continue;
      }
      s.push({ element: l, sourceMap: h });
    }
  }
  const u = s.filter(
    (l, p) => s.findIndex((h) => $r(l, h)) === p
  );
  for (const { element: l, sourceMap: p } of u) {
    let h = null;
    if (p.href) {
      const g = Yr(p.href);
      if (!g)
        continue;
      if (g.entityType === "Asset")
        h = {
          fieldId: g.fieldId,
          locale: g.locale,
          space: g.space,
          environment: g.environment,
          assetId: g.entityId
        };
      else if (g.entityType === "Entry")
        h = {
          fieldId: g.fieldId,
          locale: g.locale,
          space: g.space,
          environment: g.environment,
          entryId: g.entityId
        };
      else {
        M.warn("Unknown entityType", {
          element: l,
          sourceMap: p
        });
        continue;
      }
    } else if (p.contentful && qr(p.contentful)) {
      const g = p.contentful;
      if (!g.entity || !g.field || !g.locale || !g.space || !g.environment) {
        M.warn(
          "Element has missing information in their ContentSourceMap, please check if you have restricted the platform for the encoding. (Missing parameters in `contentful`)",
          {
            element: l,
            sourceMap: p
          }
        );
        continue;
      }
      const T = {
        fieldId: g.field,
        locale: g.locale,
        space: g.space,
        environment: g.environment
      };
      if (g.entityType === "Asset")
        T.assetId = g.entity, h = T;
      else if (g.entityType === "Entry")
        T.entryId = g.entity, h = T;
      else {
        M.warn("Unknown entityType in contentful data", {
          element: l,
          sourceMap: p
        });
        continue;
      }
    } else {
      M.warn(
        "Element has neither href nor contentful data in their ContentSourceMap, unable to extract attributes.",
        {
          element: l,
          sourceMap: p
        }
      );
      continue;
    }
    a.push({
      element: l,
      attributes: h
    });
  }
  const f = a.filter(
    ({ attributes: l }) => (l == null ? void 0 : l.manuallyTagged) === !1 || !(l != null && l.manuallyTagged)
  ).length;
  return {
    taggedElements: a,
    manuallyTaggedCount: a.length - f,
    automaticallyTaggedCount: f,
    autoTaggedElements: u
  };
}
function Ut({
  options: t
}) {
  return [
    ...new Set(
      He({ options: t }).taggedElements.map((n) => n.attributes && "entryId" in n.attributes ? n.attributes.entryId : null).filter(Boolean)
    )
  ];
}
const zr = (t, n, r = window.document) => {
  const { top: a, right: s, bottom: c, left: u } = n, f = r.elementFromPoint(u + 1, a + 1), l = r.elementFromPoint(s - 1, a + 1), p = r.elementFromPoint(u + 1, c - 1), h = r.elementFromPoint(s - 1, c - 1);
  return !(f === t && l === t && p === t && h === t);
}, Pr = (t, n = window.document) => t.map((r) => ({
  ...r,
  isVisible: r.element.checkVisibility({
    checkOpacity: !0,
    checkVisibilityCSS: !0
  }),
  isCoveredByOtherElement: zr(
    r.element,
    r.coordinates,
    n
  )
})), Hr = (t) => t.map(({ element: n, attributes: r }) => ({
  element: n,
  coordinates: n.getBoundingClientRect(),
  attributes: r
})), Vr = (t, n = window.document) => {
  const r = Hr(t);
  return Pr(r, n);
};
function Yr(t) {
  try {
    const n = new URL(t), r = n.searchParams.get("focusedField"), a = n.searchParams.get("focusedLocale"), s = n.pathname.split("/").filter(Boolean), c = s.indexOf("spaces"), u = s.indexOf("environments"), f = c !== -1 ? s[c + 1] : void 0, l = u !== -1 ? s[u + 1] : void 0;
    let p, h;
    const g = s.indexOf("entries"), T = s.indexOf("assets");
    return g !== -1 ? (p = "Entry", h = s[g + 1]) : T !== -1 && (p = "Asset", h = s[T + 1]), !p || !h ? (console.warn("Unable to determine entityType or entityId from href", { href: t }), null) : r ? a ? !f || !l ? (console.warn("Missing space or environment in href path", { href: t }), null) : {
      entityId: h,
      entityType: p,
      fieldId: r,
      locale: a,
      space: f,
      environment: l
    } : (console.warn("Missing focusedLocale query parameter in href", { href: t }), null) : (console.warn("Missing focusedField query parameter in href", { href: t }), null);
  } catch (n) {
    return console.warn("Invalid href URL", { href: t, error: n }), null;
  }
}
function qr(t) {
  return t && typeof t.entity == "string" && typeof t.field == "string" && typeof t.locale == "string" && typeof t.space == "string" && typeof t.environment == "string" && (t.entityType === "Asset" || t.entityType === "Entry");
}
class Kr {
  constructor(n) {
    E(this, "delay", 300);
    E(this, "isScrolling", !1);
    E(this, "scrollTimeout");
    E(this, "isResizing", !1);
    E(this, "resizeTimeout");
    E(this, "hoveredElement");
    E(this, "taggedElements", []);
    E(this, "manuallyTaggedCount", 0);
    E(this, "automaticallyTaggedCount", 0);
    E(this, "intersectionObserver");
    E(this, "observersCB", []);
    E(this, "cleanupCB", []);
    /**
     * Attaches the event listeners and send the tagged elements once
     */
    E(this, "init", () => {
      this.cleanupCB = [
        this.addScrollListener(),
        this.addMutationListener(document.body),
        this.addResizeListener(),
        this.addHoverListener()
      ], this.updateElements();
    });
    /**
     * Cancels all listeners and observers
     */
    E(this, "cleanup", () => {
      this.observersCB.forEach((n) => n()), this.cleanupCB.forEach((n) => n());
    });
    // Handles incoming messages from Contentful
    E(this, "receiveMessage", (n) => {
      if (n.method === te.INSPECTOR_MODE_CHANGED) {
        const { isInspectorActive: r } = n;
        r ? this.init() : this.cleanup();
      }
    });
    /** Listen for changes on the element via intersection and mutation observer */
    E(this, "observe", (n) => {
      this.intersectionObserver.observe(n);
      const r = this.addMutationListener(n);
      this.observersCB.push(r, () => this.intersectionObserver.unobserve(n));
    });
    /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */
    E(this, "addScrollListener", () => {
      const { targetOrigin: n } = this.options, r = () => {
        this.isScrolling || (this.isScrolling = !0, P(te.SCROLL_START, {}, n)), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
          this.isScrolling = !1, P(te.SCROLL_END, {}, n), this.updateElements();
        }, this.delay);
      }, a = { capture: !0, passive: !0 };
      return window.addEventListener("scroll", r, a), () => window.removeEventListener("scroll", r, a);
    });
    /** Detects DOM changes and sends the tagged elements to the editor */
    E(this, "addMutationListener", (n) => {
      const r = new MutationObserver(() => {
        this.updateElements();
      });
      return r.observe(n, {
        // Content source maps
        characterData: !0,
        // Manual tagging
        attributes: !0,
        attributeFilter: [
          m.ENTRY_ID,
          m.FIELD_ID,
          m.LOCALE,
          m.SPACE,
          m.ENVIRONMENT,
          "class",
          "style"
        ],
        // Adding or removal of new nodes
        childList: !0,
        // Include children
        subtree: !0
      }), () => r.disconnect();
    });
    /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */
    E(this, "addResizeListener", () => {
      const { targetOrigin: n } = this.options, r = new ResizeObserver(() => {
        this.isResizing || (this.isResizing = !0, P(te.RESIZE_START, {}, n)), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => {
          this.isResizing = !1, P(te.RESIZE_END, {}, n), this.updateElements();
        }, this.delay);
      });
      return r.observe(document.body), () => r.disconnect();
    });
    /** Checks if the hovered element is an tagged entry and then sends it to the editor */
    E(this, "addHoverListener", () => {
      const n = Ar((a) => {
        let s;
        for (const c of a) {
          const u = c;
          if (u.nodeName === "BODY") break;
          const f = this.taggedElements.find((l) => l.element === u);
          if (f) {
            s = f;
            break;
          }
        }
        this.hoveredElement = s == null ? void 0 : s.element, this.updateElements();
      }, this.delay), r = (a) => {
        n(a.composedPath());
      };
      return window.addEventListener("mouseover", r, { passive: !0 }), () => window.removeEventListener("mouseover", r);
    });
    E(this, "sendTaggedElements", () => {
      P(
        te.TAGGED_ELEMENTS,
        {
          elements: this.taggedElements.map((n) => ({
            // Important: do not add `element` as it can't be cloned by sendMessage
            coordinates: n.coordinates,
            isVisible: !!n.isVisible,
            attributes: n.attributes,
            isHovered: this.hoveredElement === n.element,
            isCoveredByOtherElement: !!n.isCoveredByOtherElement
          })),
          automaticallyTaggedCount: this.automaticallyTaggedCount,
          manuallyTaggedCount: this.manuallyTaggedCount
        },
        this.options.targetOrigin
      );
    });
    /**
     * Finds all elements that have all inspector mode attributes
     * and sends them to the editor
     */
    E(this, "updateElements", () => {
      const { taggedElements: n, manuallyTaggedCount: r, automaticallyTaggedCount: a } = He({
        options: this.options
      }), s = Vr(n);
      Rr(s, this.taggedElements) || (this.observersCB.forEach((c) => c()), this.observersCB = [], this.taggedElements = s, n.forEach(({ element: c }) => this.observe(c)), this.manuallyTaggedCount = r, this.automaticallyTaggedCount = a);
    });
    this.options = n, this.intersectionObserver = new IntersectionObserver(
      (r) => {
        const a = this.taggedElements;
        for (const s of r)
          if (s.isIntersecting)
            for (const c of a)
              c.element === s.target && (c.coordinates = s.intersectionRect, c.isVisible = s.target.checkVisibility({
                checkOpacity: !0,
                checkVisibilityCSS: !0
              }));
        this.taggedElements = a, this.sendTaggedElements();
      },
      { threshold: 0.15 }
    );
  }
}
const { parse: ci, stringify: Jr } = JSON, Wr = String, Zr = "string", Xr = "object", Qr = (t, n) => n, Tt = (t, n, r) => {
  const a = Wr(n.push(r) - 1);
  return t.set(r, a), a;
}, kr = (t, n, r) => {
  const a = Qr, s = /* @__PURE__ */ new Map(), c = [], u = [];
  let f = +Tt(s, c, a.call({ "": t }, "", t)), l = !f;
  for (; f < c.length; )
    l = !0, u[f] = Jr(c[f++], p, r);
  return "[" + u.join(",") + "]";
  function p(h, g) {
    if (l)
      return l = !l, g;
    const T = a.call(this, h, g);
    switch (typeof T) {
      case Xr:
        if (T === null) return T;
      case Zr:
        return s.get(T) || Tt(s, c, T);
    }
    return T;
  }
};
var H = /* @__PURE__ */ ((t) => (t.CONNECTED = "CONNECTED", t.DISCONNECTED = "DISCONNECTED", t.ERROR = "ERROR", t.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", t.URL_CHANGED = "URL_CHANGED", t.SUBSCRIBED = "SUBSCRIBED", t.UNSUBSCRIBED = "UNSUBSCRIBED", t.ENTRY_UPDATED = "ENTRY_UPDATED", t.ENTRY_SAVED = "ENTRY_SAVED", t.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", t))(H || {});
function ei(t, n) {
  P(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...t
    },
    n
  );
}
function ti(t, n) {
  P(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...t
    },
    n
  );
}
class ni {
  constructor({ locale: n, targetOrigin: r }) {
    E(this, "subscriptions", /* @__PURE__ */ new Map());
    E(this, "defaultLocale");
    E(this, "sendMessage");
    this.defaultLocale = n, this.sendMessage = (a, s) => P(a, s, r);
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(n) {
    if (n.method === H.ENTRY_UPDATED) {
      const { data: r, subscriptionId: a } = n, s = this.subscriptions.get(a);
      s ? (s.callback(r), s.data = r, this.subscriptions.set(a, s)) : M.error("Received an update for an unknown subscription", {
        subscriptionId: a,
        data: r,
        subscriptions: this.subscriptions
      });
    }
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(n) {
    const r = wr(), a = n.locale ?? this.defaultLocale;
    this.subscriptions.set(r, {
      ...n
    });
    const s = {
      locale: a,
      event: "edit",
      id: r,
      config: kr(n)
    };
    return this.sendMessage(H.SUBSCRIBED, s), () => {
      this.sendMessage(H.UNSUBSCRIBED, s), this.subscriptions.delete(r);
    };
  }
}
class ri {
  constructor({ locale: n, options: r }) {
    E(this, "locale");
    E(this, "options");
    E(this, "subscription");
    this.locale = n, this.options = r;
  }
  subscribe(n) {
    return this.subscription && M.log(
      "There is already a subscription for the save event, the existing one will be replaced."
    ), this.subscription = n, () => {
      this.subscription = void 0;
    };
  }
  receiveMessage(n) {
    if (n.method === H.ENTRY_SAVED && this.subscription) {
      const { entity: r } = n;
      Ut({ options: this.options }).includes(r.sys.id) && this.subscription(r);
    }
  }
}
const li = Dt, _t = [
  "https://app.contentful.com",
  "https://app.eu.contentful.com",
  "http://localhost:3001"
  // for local debugging for Contentful engineers
], L = class L {
  // Static method to initialize the LivePreview SDK
  static init(n) {
    var p;
    if (typeof n != "object" || !(n != null && n.locale))
      throw new Error(
        "Init function has to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const {
      debugMode: r,
      enableInspectorMode: a,
      enableLiveUpdates: s,
      locale: c,
      environment: u,
      space: f,
      targetOrigin: l
    } = n;
    if (typeof window < "u") {
      if (!Or())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (r && bt(r), typeof a == "boolean" && (this.inspectorModeEnabled = a), typeof s == "boolean" && (this.liveUpdatesEnabled = s), this.locale = c, this.space = f, this.environment = u, this.initTargetOrigin(l), this.initialized)
        return M.log("You have already initialized the Live Preview SDK."), Promise.resolve(L.inspectorMode);
      this.inspectorModeEnabled && (this.inspectorMode = new Kr({
        locale: c,
        space: f,
        environment: u,
        targetOrigin: this.targetOrigin,
        ignoreManuallyTaggedElements: (p = n.experimental) == null ? void 0 : p.ignoreManuallyTaggedElements
      })), this.liveUpdatesEnabled && (this.liveUpdates = new ni({ locale: c, targetOrigin: this.targetOrigin }), this.saveEvent = new ri({
        locale: c,
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment,
          targetOrigin: this.targetOrigin
        }
      })), window.addEventListener("message", (A) => {
        var _, D, G;
        if (Cr(A)) {
          if (M.log("Received message", A.data), A.data.method === H.DEBUG_MODE_ENABLED) {
            bt(!0);
            return;
          }
          this.inspectorModeEnabled && ((_ = this.inspectorMode) == null || _.receiveMessage(A.data)), this.liveUpdatesEnabled && ((D = this.liveUpdates) == null || D.receiveMessage(A.data), (G = this.saveEvent) == null || G.receiveMessage(A.data));
        }
      }), _r(() => {
        P(
          H.URL_CHANGED,
          {
            action: H.URL_CHANGED,
            taggedElementCount: document.querySelectorAll(
              `[${m.ENTRY_ID}]`
            ).length
          },
          this.targetOrigin
        );
      });
      const { taggedElements: h, manuallyTaggedCount: g, automaticallyTaggedCount: T } = this.inspectorModeEnabled ? He({
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment
        }
      }) : {
        taggedElements: [],
        manuallyTaggedCount: 0,
        automaticallyTaggedCount: 0
      }, N = h.length;
      return P(
        H.CONNECTED,
        {
          action: H.CONNECTED,
          connected: !0,
          tags: N,
          taggedElementCount: N,
          locale: this.locale,
          isInspectorEnabled: this.inspectorModeEnabled,
          isLiveUpdatesEnabled: this.liveUpdatesEnabled,
          manuallyTaggedElementCount: g,
          automaticallyTaggedElementCount: T
        },
        this.targetOrigin
      ), this.initialized = !0, Promise.resolve(L.inspectorMode);
    }
  }
  static initTargetOrigin(n) {
    if (n)
      this.targetOrigin = Array.isArray(n) ? n : [n];
    else {
      const r = window.location.ancestorOrigins, a = r ? _t.find((s) => r.contains(s)) : (
        //less consistent workaround for Firefox, where ancestorOrigins is not supported
        _t.find((s) => document.referrer.includes(s))
      );
      if (!a)
        throw new Error(
          "The current origin is not supported. Please provide a targetOrigin in the live preview configuration."
        );
      this.targetOrigin = [a];
    }
  }
  static subscribe(n, r) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    const a = typeof n == "string" ? n : "edit", s = typeof n == "object" ? n : r;
    if (a === "save") {
      if (!this.saveEvent)
        throw new Error(
          "Save event is not initialized, please call `ContentfulLivePreview.init()` first."
        );
      return this.saveEvent.subscribe(s.callback);
    }
    if (!this.liveUpdates)
      throw new Error(
        "Live updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(s);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps(n) {
    const { fieldId: r, locale: a, environment: s, space: c } = n;
    if (!this.inspectorModeEnabled)
      return null;
    if (r) {
      const u = {
        ...a ? { [m.LOCALE]: a } : {},
        ...s ? { [m.ENVIRONMENT]: s } : {},
        ...c ? { [m.SPACE]: c } : {},
        [m.FIELD_ID]: r
      };
      if (a && (u[m.LOCALE] = a), n.assetId !== void 0)
        return {
          ...u,
          [m.ASSET_ID]: n.assetId
        };
      if (n.entryId !== void 0)
        return {
          ...u,
          [m.ENTRY_ID]: n.entryId
        };
    }
    return M.warn("Missing property for inspector mode", { ...n }), null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  //TODO: Rename to openEntityInEditor, as assets can also be opened. Would be breaking change
  static openEntryInEditor(n) {
    const r = {
      locale: this.locale,
      environment: this.environment,
      space: this.space
    };
    if (n.assetId !== void 0 && n.fieldId) {
      ti(
        {
          ...r,
          ...n
        },
        this.targetOrigin
      );
      return;
    }
    if (n.entryId !== void 0 && n.fieldId) {
      ei(
        {
          ...r,
          ...n
        },
        this.targetOrigin
      );
      return;
    }
    M.error("Please provide field id and entry/asset id to openEntryInEditor.", { ...n });
  }
  /**
   * Returns a list of tagged entries on the page
   */
  static getEntryList() {
    return Ut({
      options: {
        locale: this.locale,
        space: this.space,
        environment: this.environment
      }
    });
  }
};
E(L, "initialized", !1), E(L, "inspectorMode", null), E(L, "liveUpdates", null), E(L, "saveEvent", null), E(L, "inspectorModeEnabled", !0), E(L, "liveUpdatesEnabled", !0), E(L, "locale"), E(L, "space"), E(L, "environment"), E(L, "sendMessage"), E(L, "targetOrigin");
let St = L;
export {
  St as C,
  te as I,
  Sr as L,
  li as V,
  si as a,
  Ir as b,
  H as c,
  Ar as d,
  ti as e,
  oi as f,
  Rr as i,
  ei as o,
  Yr as p,
  ai as u
};
//# sourceMappingURL=index-DamoDgBk.js.map
